var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"radio-container",on:{"click":function($event){$event.stopPropagation();return _vm.checkFn.apply(null, arguments)}}},[_c('img',{staticStyle:{"width":"20px","height":"20px","margin":"0 8px"},attrs:{"src":_vm.imgUrl,"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }